import React from "react";
import { useDroppable } from "@dnd-kit/core";
import List from "@mui/material/List";
import Typography from "@mui/material/Typography";
import DragItem from "../drag-item";
import { BACKEND_DROPPABLE_ID } from "../../../utils";

const BackEndColumn = ({ column }) => {
  const { setNodeRef, isOver } = useDroppable({
    id: BACKEND_DROPPABLE_ID,
    data: { type: "backend" }
  });

  return (
    <div
      style={{
        border: "1px solid lightgrey",
        borderRadius: "5px",
        flexGrow: 1,
        padding: 5,
        width: "40%",
        minHeight: 0,
        overflow: "hidden"
      }}
    >
      <div style={{ overflowY: "auto", overflowX: "hidden", padding: 15, height: "100%" }}>
        <Typography fontSize="19px!important" variant="h5">
          {column.name}
        </Typography>
        <div
          ref={setNodeRef}
          style={{
            minHeight: "calc(100% - 32px)",
            backgroundColor: isOver ? "rgba(25, 118, 210, 0.08)" : undefined
          }}
        >
          <List style={{ width: "100%" }}>
            {column.list.map((itemObject) => (
              <DragItem key={itemObject.id} itemObject={itemObject} />
            ))}
          </List>
        </div>
      </div>
    </div>
  );
};

export default BackEndColumn;
